export class HeaderModel {
  public currentBookingOptions: any = null; // current data of widget
  public valueOfCurrentRouterLink: number = 12.5;
  public steps: any = {
    clinic: 12.5,
    treatment: 25,
    practitioner: 37.5,
    date: 50,
    time: 62.5,
    details: 75,
    confirmation: 87.5,
    payment: 100
  };
  public timeoutLinkChange: any = null;
  public timeoutDateUpdate: any = null;

  constructor(currentBookingOptions: any) {
    this.currentBookingOptions = currentBookingOptions;
  }
}

export class HeaderStoreModel {
  public permission$: any = null;
  public subscribtion: any = {
    info$: null,
    router$: null
  };
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/header/header.model.ts